import { createElement, ReactNode } from 'react'

type Size = 'display-2xl' | 'display-xl' | 'display-lg' | 'display-md' | 'display-sm'

const sizes: Record<Size, string> = {
  'display-2xl': 'text-display-2xl',
  'display-xl': 'text-display-xl',
  'display-lg': 'text-display-lg',
  'display-md': 'text-display-md',
  'display-sm': 'text-display-sm',
}

type Tone = 'primary' | 'inverse'

const tones: Record<Tone, string> = {
  primary: 'text-ink-primary',
  inverse: 'text-ink-inverse',
}

interface HeadingProps {
  children: ReactNode
  as?: 'h1' | 'h2' | 'h3' | 'h4'
  size?: Size
  tone?: Tone
  className?: string
}

export default function Heading({
  children,
  as = 'h2',
  size = 'display-lg',
  tone = 'primary',
  className = '',
}: HeadingProps) {
  return createElement(
    as,
    {
      className: `${sizes[size]} ${tones[tone]} font-medium ${className}`,
    },
    children
  )
}
